import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import ImagesProjet from "./imagesProjet"

const Projects = ({ specialPadding, getOnlyFourItems }) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulPageChantier {
        edges {
          node {
            titre
            sousTitreDroite
            sousTitreGauche
            sousTitreMilieu
            texteDroite
            texteGauche
            texteMilieu
          }
        }
      }
    }
  `)

  const {
    titre,
    sousTitreDroite,
    sousTitreGauche,
    sousTitreMilieu,
    texteDroite,
    texteGauche,
    texteMilieu,
  } = data.allContentfulPageChantier.edges[0].node

  return (
    <>
      <div className="block">
        <div
          className={`special__grid ${
            specialPadding ? "--special-padding" : ""
          }`}
        >
          <div className={specialPadding ? "--special-padding" : ""}>
            {titre && <h1>{titre}</h1>}
          </div>
          <div className="item__text">
            {sousTitreGauche && <h2>{sousTitreGauche}</h2>}
            {texteDroite && <p>{texteGauche}</p>}
          </div>
          <div className="item__text">
            {sousTitreMilieu && <h2>{sousTitreMilieu}</h2>}
            {texteMilieu && <p>{texteMilieu}</p>}
          </div>
          <div className="item__text">
            {sousTitreDroite && <h2>{sousTitreDroite}</h2>}
            {texteDroite && <p>{texteDroite}</p>}
          </div>
        </div>
        <div className="block__bottom">
          <Link to="/nos-chantiers">
            <h2>Nos Chantiers</h2>
          </Link>
          <ImagesProjet getOnlyFourItems={getOnlyFourItems} />
        </div>
      </div>
    </>
  )
}

export default Projects
